import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ComprobanteVentaModel } from 'src/app/models/comprobante-venta.model';
import { SpinnerService } from 'src/app/services/spinner.service';
import { setConfigTable, validarCodigoExistentesComercial, basicAlert, alertaConfirmacionHTML3, obtenerFechaSeleccionada, obtenerFechaActual, timerOut, filtrarCoincidenciaArrayTransportista, validarInputVacio, alertaConfirmacion, openDescripcion, openObservacion, alertaConfirmacionHTML } from 'src/app/shared/utils';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { ModalBusquedaInterlocutorComponent } from '../busqueda/modal-busqueda-interlocutor/modal-busqueda-interlocutor.component';
import { MdActualizarDamComponent } from 'src/app/shared/modals/md-actualizar-dam/md-actualizar-dam.component';
import { BuscarService } from 'src/app/services/buscar.service';
import { UsuarioService } from 'src/app/services/usuarios.service';
import { RecursosService } from 'src/app/services/recursos.service';
import { StorageService } from 'src/app/services/storage.service';
import {documentoService} from 'src/app/services/documento.service'
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DecimalPipe, DatePipe } from '@angular/common';
import { FacturaService } from 'src/app/services/factura.service';
import { BoletaService } from 'src/app/services/boleta.service';
import { DocumentoCabeceraService } from 'src/app/services/documento-cabecera.service';
import { MdActualizarPlacaComponent } from '../md-actualizar-placa/md-actualizar-placa.component';
import { GuiaInternaService } from 'src/app/services/GuiaInterna.service';
import { ConsultaCotizacionService } from 'src/app/services/comercial-consulta-cotizacion.service';
import { OrdenpedidoService } from 'src/app/services/ordenpedido.service';
import { GuiaremisionService } from 'src/app/services/guiaremision.service';
import { OrdCompraService } from 'src/app/services/OrdCompra.service';
import { DocImportacionService } from 'src/app/services/DocImportacion.service';
import { ReqCompraService } from 'src/app/services/ReqCompra.service';
import { OrdenProduccionService } from 'src/app/services/orden-produccion.service';
import { ConsultaService } from 'src/app/services/consulta.service';
import { TrazabilidadComponent } from '../trazabilidad/trazabilidad.component';
import * as FileSaver from 'file-saver';
import { PortalWebService } from 'src/app/services/portal-web.service';
import { ToastrService } from 'ngx-toastr';
import { CuentaPorCobrarService } from 'src/app/services/cuentaporcobrar.service';
import { MdDocCuentaCobrarComponent } from '../md-doc-cuenta-cobrar/md-doc-cuenta-cobrar.component';
import { AsientoService } from 'src/app/services/asiento.service';

@Component({
  selector: 'app-md-documento',
  templateUrl:'./md-documento.component.html',
  styleUrls: ['./md-documento.component.css']
})
export class MdDocumentoComponent implements OnInit {
  obj:any={};
  @Input() documento: any = {};
  @Input() encontrado: boolean;
  @Input() enDoc:boolean=false;
  @Input() actDam:boolean;
  @Input() traz:boolean=false;
 
  verCostos: boolean = false;
  resultKardex: any[] = [];
  dtTrigger: Subject<null> = new Subject();
  dtOptions: any = {};
  usuarios: any[] = [];

  public sessionInfo: any = {};
  cotizacionChecada: any
  public formulario: boolean = false;
  public resultados: boolean = false;
  public codTipoInventario: number = -1;
  public codArticulo: any = -1
  public codAlmacen: number = -1;
  public almacenDefecto: number = null;
  public tipoChange: number = null;
  public tipoSearch: number = null;
  public periodo: any = 2022;
  public mes: any = '';

  public viewperiodo: number = 2022;
  public viewmes: any;

  //Variables finales
  public ingresos: number = 0;
  public salidas: number = 0;
  public stockFinal: number = 0;
  public result: number = 0;
  public tipostock: string = ""

  public desArticulo: string = '';
  public tipoInterfaz: string = '';
  public buscarArticulo: string = 'buscar';
  public etiqueta: string = '';
  public calidad: string = '';
  public color: string = '';
  public rucEmpresa: string = '';
  public tipoControlStock: string = '';

  public almacenes: any[] = [];
  public articulos: any[] = [];
  public kardex: any[] = [];
  public tiposInventario: any[] = [];
  public controlStocks: any[] = [];

  public disabledArticulo: boolean = true;
  public disabledAlmacen: boolean = true;
  public loading: boolean = false;
  public disabledPeriodo: boolean = false;
  public disabledMes: boolean = false;

  public _recursos: any = {};

  public trazabilidades: any[] = [];
  public listipostock: any[] = [];
  public motivos: any = [];

  public stockini: number = 0;
  public decimal;
  buscarInterlocutor: string = 'buscar'
  disabledInterlocutor: boolean = false;
  codInterlocutor
  desInterlocutor
  public iRecursos: any = {};

  // nueva variables
  motivo:any;
  motivo2:any;

  constructor(private modalService: NgbModal,
    private modalService2: NgbActiveModal,
    private spinnerService: SpinnerService,
    private interlocutorService: InterlocutorService,
    private _buscarService: BuscarService,
    private usuarioService: UsuarioService,
    private recursosService: RecursosService,
    private documentoService: documentoService,
    private decimalPipe: DecimalPipe,
    private facturaService: FacturaService,
    private docCabService: DocumentoCabeceraService,
    private boletaService: BoletaService,
    private guiaInternaService: GuiaInternaService,
    private cotizacionService: ConsultaCotizacionService,
    private ordenPedidoService: OrdenpedidoService,
    private gremisionService: GuiaremisionService,
    private ordCompraService: OrdCompraService,
    private DocImportacionService: DocImportacionService,
    private reqCompraService: ReqCompraService,
    private OrdenProduccionService: OrdenProduccionService,
    private consultaService: ConsultaService,
    private portalWebService: PortalWebService,
    private asientoService: AsientoService,
    private toastr: ToastrService,
    private readonly CuentaPorCobrarService:CuentaPorCobrarService,
    ) { }

  ngOnInit(): void {
    this.sessionInfo = JSON.parse(StorageService.getSession());
    this.decimalprecio = this.sessionInfo.factores.decimalesComercialPrecio
    console.log('Detalle documento',this.documento)
    this.cargarDocmentosTipo()
    this.getUsuarios()
    this.buscarRecursos()
    console.log("DOCUMENTO PROBANDO");
    console.log( Object.keys(this.documento).length === 0 )

     if(Object.keys(this.documento).length === 0){
      this.documento={};
      this.encontrado = true;
     }else{
      //ECONTRÓ DOCUMENTO 
      this.documento.detalles=this.documento.detalle;
      this.reordenar()
      this.encontrado = false;
     }
     console.log("DAM")
     console.log(this.actDam)
     console.log("this.documento.comprobanteOrigen")
     console.log(this.documento.comprobanteOrigen)

     
  }

  reordenar() {

    for (let i = 0; i < this.documento.detalle.length; i++) {
      this.documento.detalle[i].positi = i + 1;
      this.documento.detalle[i].tipinv = this.documento.detalle[i].tipinv;
      this.documento.detalle[i].codart = this.documento.detalle[i].codart;  
      this.documento.detalle[i].desart = this.documento.detalle[i].desart;
      this.documento.detalle[i].codalm = this.documento.detalle[i].codalm;
      this.documento.detalle[i].undmed = this.documento.detalle[i].undmed;
      this.documento.detalle[i].codadd01 = this.documento.detalle[i].codadd01
      this.documento.detalle[i].codadd02 = this.documento.detalle[i].codadd02
      this.documento.detalle[i].cantid = this.decimalPipe.transform(this.documento.detalle[i].cantid !=null ? this.documento.detalle[i].cantid : 0, `0.2-2`);
      this.documento.detalle[i].preuni =  this.decimalPipe.transform(this.documento.detalle[i].preuni !=null ? this.documento.detalle[i].preuni : 0, `0.2-2`);
      this.documento.detalle[i].pordes1 = this.decimalPipe.transform(this.documento.detalle[i].pordes1 !=null ? this.documento.detalle[i].pordes1 : 0, `0.2-2`);
      this.documento.detalle[i].pordes2 = this.decimalPipe.transform(this.documento.detalle[i].pordes2 !=null ? this.documento.detalle[i].pordes2 : 0, `0.2-2`);
      this.documento.detalle[i].pordes3 = this.decimalPipe.transform(this.documento.detalle[i].pordes3 !=null ? this.documento.detalle[i].pordes3 : 0, `0.2-2`);
      this.documento.detalle[i].pordes4 = this.decimalPipe.transform(this.documento.detalle[i].pordes4 !=null ? this.documento.detalle[i].pordes4 : 0, `0.2-2`);
      this.documento.detalle[i].observ = this.documento.detalle[i].observ
      this.documento.detalle[i].etiqueta = this.documento.detalle[i].etiqueta
      this.documento.detalle[i].descodadd01 = this.documento.detalle[i].descodadd01
      this.documento.detalle[i].descodadd02 = this.documento.detalle[i].descodadd02
      this.documento.detalle[i].lote = this.documento.detalle[i].lote
      this.documento.detalle[i].ancho = this.documento.detalle[i].ancho
      this.documento.detalle[i].importe =this.decimalPipe.transform(this.documento.detalle[i].importe !=null ? this.documento.detalle[i].importe : 0, `0.2-2`);

    }

  }

  public buscarRecursos() {
    if(this.documento!=null && this.documento!=undefined){
        this.spinnerService.activarLoading(true);
        this.recursosService.getRecursos(this.documento.tipdoc, this.sessionInfo.codsuc, false).subscribe((resp: any) => {
          this.spinnerService.activarLoading(false);
          this.iRecursos = resp.body;
          this.motivos = this.iRecursos.motivos;
            this.motivos.forEach(element => {
              if (element.codmot == this.documento.codmot) {
                this.documento.desmot = element.desmot
              }
            });
      
          

        }, err => {
          this.spinnerService.activarLoading(false);
        })
    }
  }

  onNexFocus(tipo: string){

  }
  cerrar(){
    this.modalService2.dismiss('canceling');
  }
  onKeyup(){

  }
  onKeyEnterCodInterlocutor(e, codcli) {
    console.log("onKeyEnterCodInterlocutor")
    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    if (tecla == 13) {
      if (codcli != '') {
        this.spinnerService.activarLoading(true);
        this.getByCodInterlocutor(codcli, 2);
      }
    }
    // return (tecla != 13);
  }
  
  getByCodInterlocutor(codcli: string, tipoSearch: number) {
    let d = {};

    let d1 = {};
    this.interlocutorService.obtenerInterlocutor(codcli, true).subscribe((response: any) => {
      console.log('Datos de interlocutor');
      console.log(response.body);
      this.disabledInterlocutor = true;
      this.spinnerService.activarLoading(false);
      this.codInterlocutor = response.body.codcli;
      this.desInterlocutor = response.body.razonc;
      this.buscarInterlocutor = 'borrar';
     
    },
      err => {
        console.log(err);
        if (err.status == 404) {
          basicAlert('No se encontró información para el Interlocutor seleccionado', 'warning', 'Aceptar');
        }

        this.codInterlocutor = '';
        this.desInterlocutor = '';

        this.spinnerService.activarLoading(false);
      });
  }

  onKeyEnterInterlocutor(e) {
    this.openModalInterlocutor();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }
  interlocutores: any[] = [];


  openModalInterlocutor() {
    if (this.desInterlocutor.length < 3) {
      basicAlert('Se requiere palabra mayor a 3 caracteres.', 'warning', 'Aceptar', null, null, null);
      return
    }

    let codcli: string = '';
    let razonc: string = "%" + this.desInterlocutor + "%";
    let nombres: string = "%" + this.desInterlocutor + "%";
    let dident: string = '';
    let soloactivos: boolean = true;
    let limit: number = 350;
    let offset: number = 0;

    console.log(razonc)

    if (this.desInterlocutor.length > 0) {
      this.spinnerService.activarLoading(true);
      this.interlocutorService.buscarInterlocutor(codcli, razonc, nombres, dident, soloactivos, limit, offset).subscribe((response: any) => {
        console.log(response);
        this.interlocutores = response.body;
        this.mostrarModalInterlocutor();
      }, err => {
        console.log(err);
        if (err.status == 404) {
          basicAlert('No hay resultados', 'warning', 'Aceptar', null, null);
        }
        this.spinnerService.activarLoading(false);
      });
    } else {
      basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar', null, null);
      return;
    }
  }
  
  mostrarModalInterlocutor() {
    const referenciaModal = this.modalService.open(ModalBusquedaInterlocutorComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });
    referenciaModal.componentInstance.cabeceraTexto = 'comercial'
    referenciaModal.componentInstance.interlocutores = this.interlocutores;
    referenciaModal.componentInstance.interlocutores_temp = this.interlocutores;
    referenciaModal.result.then((data) => {
      console.log(data);
      this.getByCodInterlocutor(data.codcli, 2)
    }, (reason) => {
      console.log(reason);
    });
  }



  borrarDatosInterlocutor() {

    this.codInterlocutor = '';
    this.desInterlocutor = '';
    this.disabledInterlocutor = false;
    this.buscarInterlocutor = 'buscar';
  }

  tipdoc
  public tiposDocumentos: any[] = [];

  cargarDocmentosTipo() {
    this._buscarService.documentos_tipo("", "").subscribe((resp: any) => {
      console.log("tipos de documento");
      console.log(resp);
      this.tiposDocumentos = resp.body;
    }, err => {
      console.log(err);
    })
  }

  public getUsuarios() {
    this.spinnerService.activarLoading(true);
    let listausuarios = [];
    this.usuarios = [];
    let cod = encodeURI('123%')
    this.usuarioService.obtenerUsuarios('', '').subscribe(response => {
    this.usuarios = response.body;
    if(this.documento!=null && this.documento!=undefined){
      this.usuarios.forEach(element2 => {
        if (element2.coduser == this.documento.usuari) {
          this.documento.descusuario = element2.nombres
        }
      });
     }
    

    console.log(response)
    this.spinnerService.activarLoading(false);

    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      //this.dtTrigger.next();
    })
  }
  
  consultar(){
    this.spinnerService.activarLoading(true);
    this.documentoService.obtenerTipdocSerieNumero(this.documento.tipdoc,this.documento.series,this.documento.numdoc,true).subscribe(response=>{
      console.log(response);
      this.spinnerService.activarLoading(false);
        this.documento=response.body; 
        this.enDoc=true;
        this.getUsuarios();
        this.buscarRecursos();
        this.reordenar();
    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      //this.dtTrigger.next();
    })
  }
  viewPdf(doc: any) {
    if (doc.byteLength > 0) {
      let file = new Blob([doc], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } else {
      basicAlert('Archivo no disponible..', 'warning', 'Aceptar', null, null, null);
    }
  }
  imprimir() {
    let tiposValidos = [1, 3, 7, 100, 101, 102, 103, 104, 105, 115, 125]
    if(!tiposValidos.includes(this.documento.tipdoc)){
      basicAlert('Falta implementar/configurar.', 'warning', 'Aceptar', null, null, null);
    }

    if (this.documento.tipdoc == 1) {
      this.spinnerService.activarLoading(true);

      this.facturaService.download_pdf(3, this.documento.numint, this.sessionInfo.cia).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        console.log(response);
        if (response.byteLength > 0) {
          let file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
        }
      }, err => {
        console.log(err)
        this.spinnerService.activarLoading(false);
        basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
      });

    } 
     if (this.documento.tipdoc == 3) {
      this.spinnerService.activarLoading(true);
      this.boletaService.download_pdf(3, this.documento.numint, this.sessionInfo.cia).subscribe(((response: any) => {
        this.spinnerService.activarLoading(false);
        this.viewPdf(response);
      }), err => {
        this.spinnerService.activarLoading(false);
        basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
      })
     }  
    if (this.documento.tipdoc == 7) {
      this.spinnerService.activarLoading(true);
      this.docCabService.download_pdf(this.documento.tipdoc, this.sessionInfo.id_cia, this.documento.numint).subscribe(((resp: any) => {
        this.spinnerService.activarLoading(false);
        // if (resp.byteLength > 0) {
        //   let file = new Blob([resp], { type: 'application/pdf' });
        //   var fileURL = URL.createObjectURL(file);
        //   window.open(fileURL);
        // } else {
        //   basicAlert('Archivo no disponible..', 'warning', 'Aceptar', null, null, null);
        // }
        this.spinnerService.activarLoading(true);
        this.boletaService.download_pdf(3, this.documento.numint, this.sessionInfo.cia).subscribe(((response: any) => {
          this.spinnerService.activarLoading(false);
          this.viewPdf(response);
        }), err => {
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        })
      }), err => {
        this.spinnerService.activarLoading(false);
        basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);

      })
    }
    if (this.documento.tipdoc == 103) {
      this.spinnerService.activarLoading(true);
    this.guiaInternaService.download_pdf(1, this.documento.numint, this.sessionInfo.cia).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
    });

    }
    if(this.documento.tipdoc == 100){
      this.spinnerService.activarLoading(true);
      this.cotizacionService.downloadCotizacionFormato1(this.documento.numint, this.sessionInfo.cia).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        console.log(response);
        if (response.byteLength > 0) {
          let file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
        }
      }, err => {
        console.log(err)
        this.spinnerService.activarLoading(false);
        basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
      });
    }
    if(this.documento.tipdoc == 101){
      this.spinnerService.activarLoading(true);
      this.ordenPedidoService.download_pdf(1, this.documento.numint, this.sessionInfo.cia).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        console.log(response);
        if (response.byteLength > 0) {
          let file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
        }
      }, err => {
        console.log(err)
        this.spinnerService.activarLoading(false);
        basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
      });
    }
    if(this.documento.tipdoc == 102){
      this.spinnerService.activarLoading(true);
    this.gremisionService.descargarPDF(this.documento.numint, this.sessionInfo.cia).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
    });
    }
    if(this.documento.tipdoc == 105){
      this.spinnerService.activarLoading(true);
    this.ordCompraService.download_pdf(1, this.documento.numint, this.sessionInfo.cia).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
    });
    }
    if(this.documento.tipdoc == 115){
        this.spinnerService.activarLoading(true);
      this.DocImportacionService.download_pdf(1, this.documento.numint, this.sessionInfo.cia).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        console.log(response);
        if (response.byteLength > 0) {
          let file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
        }
      }, err => {
        console.log(err)
        this.spinnerService.activarLoading(false);
        basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
      });
    }
    if(this.documento.tipdoc == 125){
      this.spinnerService.activarLoading(true);
    this.reqCompraService.download_pdf(1, this.documento.numint, this.sessionInfo.cia).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
    });
    }

    if (this.documento.tipdoc == 104) {
        console.log("con Imprimir")
        this.spinnerService.activarLoading(true);
        this.OrdenProduccionService.descargarPDF(1, this.documento.numint, this.sessionInfo.cia).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          if (response.byteLength > 0) {
            let file = new Blob([response], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          } else {
            basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
          }
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
        });
    }
  }

  imprimir_desc(lst){

  }
  imprimir_ticket(lst){

  }
  imprimirguiarem(lst){

  }
  downloadPDF(lst){

  }
  actaEntrega(data:any){
      this.spinnerService.activarLoading(true);
      this.documentoService.obtenerpdfFormatoActaEntrega(this.documento.numint,data.numite).subscribe((response:any)=>{
        this.spinnerService.activarLoading(false);
        console.log(response);
        // if(response.byteLenght>0){
          let file= new Blob([response],{type:"application/pdf"});
          var fileURL=URL.createObjectURL(file);
          window.open(fileURL);
        // }else{
        //   basicAlert('No hay resultados.','warning','Aceptar',null,null,null);
        // }
        
      }, err=>{
        console.log(err);
        this.spinnerService.activarLoading(false);
        basicAlert('Impresion de documento no disponible','warning','Aceptar',null,null,null);
      }
      
      )           
  }
  decimalprecio
  decimalcantidad
  decimalFormatCantidad(data: any) {
    this.documento.documento.detalle.forEach(element => {
      if (element.positi == data.positi) {
        element.cantid = this.decimalPipe.transform(element.cantid, `0.` + this.decimalcantidad + `-` + this.decimalcantidad);
      }
    });
  }

  decimalFormatPrecio(data: any) {
    this.documento.documento.detalle.forEach(element => {
      if (element.positi == data.positi) {
        element.preuni = this.decimalPipe.transform(element.preuni, `0.` + this.decimalprecio + `-` + this.decimalprecio);
        // element.preuni = parseFloat(element.preuni).toFixed(2)
      }
    });
  }

  decimalFormatDescuento(desc: number, numero: number, positi: number) {
    this.documento.documento.detalle.forEach(element => {
      if (element.positi == positi) {
        if (numero > 100) {
          switch (desc) {
            case 1:
              element.pordes1 = this.decimalPipe.transform(100, `0.2-2`);
              break;

            case 2:
              element.pordes2 = this.decimalPipe.transform(100, `0.2-2`);
              break;

            case 3:
              element.pordes3 = this.decimalPipe.transform(100, `0.2-2`);
              break;

            case 4:
              element.pordes4 = this.decimalPipe.transform(100, `0.2-2`);
              break;
          }
        } else {
          switch (desc) {
            case 1:
              element.pordes1 = this.decimalPipe.transform(element.pordes1, `0.2-2`);
              break;

            case 2:
              element.pordes2 = this.decimalPipe.transform(element.pordes2, `0.2-2`);
              break;

            case 3:
              element.pordes3 = this.decimalPipe.transform(element.pordes3, `0.2-2`);
              break;

            case 4:
              element.pordes4 = this.decimalPipe.transform(element.pordes4, `0.2-2`);
              break;
          }
        }
      }
    });
  }
  openModalDam(){
    const referenciaModal = this.modalService.open(MdActualizarDamComponent, { scrollable: true, windowClass: 'modal-short', backdrop: 'static' });
    referenciaModal.componentInstance.numint = this.documento.numint;
    referenciaModal.componentInstance.valorDam=this.documento.detalle[0].dam;
    referenciaModal.result.then((data) => {
      console.log(" data devuelta");
      console.log(data);
      this.openModalDocumento();
    }, (reason) => {
      console.log(reason);
    });
  }

  actualizarPlaca(data:any){
    const referenciaModal = this.modalService.open(MdActualizarPlacaComponent, { scrollable: true, windowClass: 'modal-short', backdrop: 'static' });
    referenciaModal.componentInstance.valEtiqueta=data.etiqueta;
    referenciaModal.componentInstance.valorPlaca=data.placa;
    referenciaModal.result.then((dato) => {
      console.log(" data devuelta");
      console.log(dato);
      this.openModalDocumento();
    }, (reason) => {
      console.log(reason);
    });
  
  }
  openModalDocumento(){
    this.spinnerService.activarLoading(true);
    this.documentoService.obtenerDetalleDocumento(this.documento.numint, true).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      this.documento = response.body;
    }, err => {
      console.log(err);
      if (err.status == 404) {
        basicAlert('No hay resultados', 'warning', 'Aceptar', null, null);
      }
      this.spinnerService.activarLoading(false);
    });
}

trazabilidad() {
  this.spinnerService.activarLoading(true);
  this.consultaService.getListTrazabilidadDocumentos(this.documento.numint).subscribe((response: any) => {
    if (response.status != 404) {
      //if (response.list) {
      this.trazabilidades = response.body.list;
      console.log(this.trazabilidades);
      this.mostrarModalTrazabilidad();

      //this.childModalTrazabilidad.show();
      //this.childModalTrazabilidad.config = { keyboard: false };
      this.spinnerService.activarLoading(false);
      //} else {
      //    basicAlert('No hay resultados', 'warning', 'Aceptar', null, null, null);
      //    this.spinnerService.activarLoading(false);
      //  }
    } else {
      this.spinnerService.activarLoading(false);
      basicAlert('Servicio no disponible', 'warning', 'Aceptar', null, null, null);
    }
  }, err => {
    this.spinnerService.activarLoading(false);
    basicAlert('Servicio no disponible', 'warning', 'Aceptar', null, null, null);

  });
}
mostrarModalTrazabilidad() {
  const referenciaModal = this.modalService.open(TrazabilidadComponent, { scrollable: true, windowClass: 'modal-lg-mytheme', backdrop: 'static' });
  //referenciaModal.componentInstance.cabeceraTexto = 'comercial'
  referenciaModal.componentInstance.trazabilidades = this.trazabilidades;

  referenciaModal.result.then((data) => {
    console.log(data);
    //this.getByCodInterlocutor(data.codpro)
  }, (reason) => {
    console.log(reason);
  });
}

download_xml(doc: any) {
  console.log('Doc',doc)
  this.spinnerService.activarLoading(true);
  this.docCabService.descargarXML(this.sessionInfo.id_cia, doc.numint)
    .subscribe((response: any) => {
      console.log(response)
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: 'application/zip' });
        var fileURL = URL.createObjectURL(file);
        FileSaver.saveAs(fileURL, `${this.sessionInfo.ruc}-0${doc.tipdoc}-${doc.series}-${doc.numdoc}.zip`);
      } else {
        basicAlert('No hay resultados', 'warning', 'Aceptar');
      }
      this.spinnerService.activarLoading(false);
    }, err => {
      console.log(err)
      basicAlert('No hay resultados', 'warning', 'Aceptar');
      this.spinnerService.activarLoading(false);
    })
}

download_cdr(doc: any) {
  console.log('Doc',doc)
  this.spinnerService.activarLoading(true);
  this.docCabService.descargarCDR(this.sessionInfo.id_cia, doc.numint).subscribe((response: any) => {
    console.log(response)
    if (response.byteLength > 0) {
      let file = new Blob([response], { type: 'application/zip' });
      var fileURL = URL.createObjectURL(file);
      FileSaver.saveAs(fileURL, `R-${this.sessionInfo.ruc}-0${doc.tipdoc}-${doc.series}-${doc.numdoc}.zip`);
    } else {
      basicAlert('No hay resultados', 'warning', 'Aceptar');
    }
    this.spinnerService.activarLoading(false);
  }, err => {
    basicAlert('No hay resultados', 'warning', 'Aceptar');
    this.spinnerService.activarLoading(false);
  })
}

enviarCorreo(data: any) {
  console.log("data extraída")
  console.log(data)
  this.spinnerService.activarLoading(true);
  this.interlocutorService.obtenerContactos(data.codcli, true)
    .subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      let _contactos: any = [];

      console.log(resp);
      if (resp.body.list != null)
        resp.body.list.forEach((element: any) => {
          if (element.correo != null && element.recibeComprobanteElec != null && element.recibeComprobanteElec) {
            _contactos.push({
              nombre: element.nomcont,
              email: element.correo
            })
          }
        });

      if (_contactos != null && _contactos.length > 0) {
        let comp: any = {
          success: "",
          message: "",
          comprobante: {
            rucCia: this.sessionInfo.ruc,
            ruc: data.ruc,
            serie: data.serie,
            numero: data.numero,
            tipoDocumento: data.tipDoc
          },
          contactos: _contactos
        };

        this.spinnerService.activarLoading(true);
        this.portalWebService.sendCorreo(this.sessionInfo.id_cia, data.numint).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          basicAlert('Se envió el comprobante.', 'success', 'Aceptar');

        }, err => {
          this.spinnerService.activarLoading(false);
          console.log(err);
          if (err.status == 404) {
            basicAlert('No se enviaron los documentos.', 'warning', 'Aceptar');
          }
        });
      } else {
        basicAlert('Interlocutor comercial no tiene contactos configurados para el envio de comprobantes.', 'warning', 'Aceptar');
      }

    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err);
      basicAlert('Interlocutor comercial no tiene contactos configurados para el envio de comprobantes.', 'warning', 'Aceptar');
    })
}

obtenerCuentaPorCobrar(){
  this.spinnerService.activarLoading(true);
  this.CuentaPorCobrarService.consultaDocumentosPendientes(this.documento.numint).subscribe((resp:any)=>{
    this.spinnerService.activarLoading(false);
    console.log('CXC',resp.body)
    if(resp.body.length==0){
      basicAlert('No se encontro resultado','warning','Aceptar');
      return;
    }
    this.openModalCuentaPorCobrar(resp.body);
  },err=>{
    this.spinnerService.activarLoading(false);
    basicAlert("No se encontró cuenta por cobrar",'error','Aceptar');
  });
}

openModalCuentaPorCobrar(data:any) {
  const referenciaModal = this.modalService.open(MdDocCuentaCobrarComponent, { scrollable: true, windowClass:'md-cuenta-cobrar', backdrop: 'static' });
     referenciaModal.componentInstance.cuentasPorCobrar=data;
  referenciaModal.result.then((data) => {
  });
}

validarTipoDocumento(){
  let tiposValidos = [1, 3, 7, 8]
  return (tiposValidos.includes(this.documento.tipdoc))?true:false;
}

imprimirAsientoProceso(data: any) {
  //basicAlert('Función en desarrollo.', 'warning', 'Aceptar', null, null, null);
  this.spinnerService.activarLoading(true);

  this.asientoService.download_asiento_proceso(this.sessionInfo.id_cia, data.periodo, data.mes, data.asiento, data.libro).subscribe((response: any) => {
    this.spinnerService.activarLoading(false);
    console.log(response);
    if (response.byteLength > 0) {
      let file = new Blob([response], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } else {
      this.toastr.warning('No hay resultados.', "", { "positionClass": "toast-bottom-left" });
    }
  }, err => {
    console.log(err)
    this.spinnerService.activarLoading(false);
    this.toastr.warning('Impresión de documento no disponible.', "", { "positionClass": "toast-bottom-left" });
  });
}
imprimirAsientoContabilizado(data: any) {
  console.log(data)
  console.log(this.sessionInfo.id_cia)

  this.spinnerService.activarLoading(true);

  this.asientoService.download_asiento_contabilizado(this.sessionInfo.id_cia, data.periodo, data.mes, data.asiento, data.libro).subscribe((response: any) => {
    this.spinnerService.activarLoading(false);
    console.log(response);
    if (response.byteLength > 0) {
      let file = new Blob([response], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } else {
      this.toastr.warning('No hay resultados.', "", { "positionClass": "toast-bottom-left" });
    }
  }, err => {
    console.log(err)
    this.spinnerService.activarLoading(false);
    this.toastr.warning('Impresión de documento no disponible.', "", { "positionClass": "toast-bottom-left" });
  });
}
}
